import inputsConfig from "./inputConfig";

export default {
  accordion: false,
  items: [
    {
      name: "Send an invoice",
      required: true,
      fields: inputsConfig.email,
    },
    {
      name: "Invoice amount (in USD)",
      required: true,
      fields: inputsConfig.amount,
    },
    {
      name: "Campaign type for this invoice",
      required: false,
      fields: inputsConfig.campaign_type,
    },
  ],
};
